import Settings from 'app/developer-v3/pages/settings';

export default {
  routes: {
    '.': Settings,
  },
};
